import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import $ from "jquery";
import { setPlayingAction } from "../../lib/store/actions/pageActions";
import VideoList from "../../components/VideoList/index";
import logo from "../../assets/white-logo.svg";
import { isLoggedIn, deleteUser, getUserInfo } from "../../lib/session";

const Library = props => {
  const {
    currentlyPlaying,
    dispatch,
    history,
    track,
    path,
    logout,
    designType
  } = props;
  const type = path.replace("/", "").toLowerCase();
  const { userDetails: { activity = [] } = {} } = getUserInfo("data") || {};
  const numLogins =
    activity &&
    activity.map(obj => obj && obj.action === "login").filter(n => n).length;

  const resize = () => {
    setWinWidth($(window).width() - 10);
  };

  const [winWidth, setWinWidth] = useState(0);

  useEffect(() => {
    resize();
    window.addEventListener("resize", resize);
    $("html, body")
      .stop()
      .animate({ scrollTop: 0 }, 500);
    return () => {
      window.removeEventListener("resize", resize);
    };
  }, []);

  const firstTimeVisitor = numLogins === 1 && !getUserInfo("loaded");

  return (
    <>
      <div className="library">
        <div className={`imageContainer hero-container ${designType}`}>
          <div className="d-flex flex-row-reverse logout-container">
            <a className="p-2 logout-link" href="#" onClick={logout}>
              Logout
            </a>
          </div>
          <div className="logoContainer">
            <img src={logo} alt="logo" className="logo" />
          </div>
          <div className="darkgradient" />
        </div>

        <VideoList
          section={type}
          winWidth={winWidth}
          playVideo={id => id !== "" && dispatch(setPlayingAction(id))}
          operation="redirect"
          currentlyPlaying={currentlyPlaying}
          track={track}
          designType={designType}
          firstTimeVisitor={firstTimeVisitor}
        />
      </div>
    </>
  );
};

const mapStateToProps = state => ({
  currentlyPlaying: state.pageReducers.currentlyPlaying
});

export default connect(mapStateToProps)(Library);
